module.exports = __webpack_public_path__ + "img/logo3.237f3471.png";